var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-select c-select--no-before select-license"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',[_c('CheckboxListItem',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"item":{
          checked: _vm.checked,
          value: _vm.value,
          title: _vm.title
        }},on:{"childToParent":_vm.childToParent}}),_c('span',{staticClass:"select-license__validate"},[_vm._v(_vm._s(_vm.valid ? 'Skal udfyldes' : ''))])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }